module.exports = __webpack_public_path__ + "static/media/refer.6acbc2a2.svg";